import { getGlobalClassNames } from '@uifabric/styling';
var GlobalClassNames = {
    root: 'ms-CardItem'
};
var baseTokens = {
    padding: 0
};
var filledTokens = {
    margin: 0
};
export var CardItemTokens = function (props, theme) { return [
    baseTokens,
    props.fill && filledTokens
]; };
export var CardItemStyles = function (props, theme, tokens) {
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            theme.fonts.large,
            classNames.root,
            {
                margin: tokens.margin,
                padding: tokens.padding
            }
        ]
    };
};
//# sourceMappingURL=CardItem.styles.js.map